export let MessageKey;

(function (MessageKey) {
  MessageKey["CheckYourEmail"] = "CHECK_YOUR_EMAIL";
  MessageKey["CrmCentralPlace"] = "CRM_CENTRAL_PLACE";
  MessageKey["WordpressConnect"] = "WORDPRESS_CONNECT";
  MessageKey["BlondeShelley"] = "BLONDE_SHELLEY";
  MessageKey["HubInterestLandingPage"] = "HUB_INTEREST_LANDING_PAGE";
  MessageKey["HubInterestMarketing"] = "HUB_INTEREST_MARKETING";
  MessageKey["HubInterestSales"] = "HUB_INTEREST_SALES";
  MessageKey["HubInterestCustomerService"] = "HUB_INTEREST_CUSTOMER_SERVICE";
  MessageKey["HubInterestCms"] = "HUB_INTEREST_CMS";
  MessageKey["CampaignAssistant"] = "CAMPAIGN_ASSISTANT";
  MessageKey["BlogGenerator"] = "BLOG_GENERATOR";
})(MessageKey || (MessageKey = {}));